import { Status } from '../License/types/enums';

export enum SearchSelectField {
  id = 'id',
  status = 'status',
  licenseType = 'licenseType',
  userReferenceNumber = 'userReferenceNumber',
  approvalReference = 'approvalReference',
  approvalDate = 'approvalDate',
  companyCode = 'companyCode',
  lastOperationDate = 'lastOperationDate',
  companyDescription = 'companyDescription',
  requestNumber = 'requestNumber',
  ministryCode = 'ministryCode',
  departmentCode = 'departmentCode',
  departmentOfficeCode = 'departmentOfficeCode',
  commodityCode = 'items.commodityCode',
  ogaStatus = 'ogaStatus',
  ogaStatusInNationalLang = 'ogaStatusInNationalLang',
  requestDate = 'requestDate',
}

export const licenseSelectFields = Object.keys(SearchSelectField).filter((field) => field !== 'commodityCode');

export const newRequestStatuses = [
  Status.PENDING_PAYMENT,
  Status.REQUESTED,
  Status.QUERIED,
  Status.PARTIALLY_APPROVED,
  Status.AMENDMENT_REQUESTED,
  Status.STORED,
];
export const lpcoListStatuses = [
  Status.APPROVED,
  Status.PARTIALLY_USED,
  Status.USED,
  Status.SUSPENDED,
  Status.EXPIRED,
  Status.REJECTED,
  Status.CANCELED,
];
